module.exports = __webpack_public_path__ + "static/media/footer_banner.f7b2f1a8.png";